import React, { FC } from "react";
import { Menu, Typography } from "antd";
import { listMenu } from "../../constants/menu.constant";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";

type MenuProps = {
  isDark?: boolean;
  name?: string;
  isMobile?: boolean;
  setVisible: (value: boolean) => void;
};
const MainMenu: FC<MenuProps> = ({ isMobile, setVisible }) => {
  const { Title } = Typography;
  const { pathname }: any = useLocation();
  const activeSection = pathname.split("/")[2];

  return (
    <>
      <div
        className="logo"
        style={{
          height: "69px",
          background: "#001529",
          overflow: "hidden",
        }}
      >
        <Title
          level={3}
          style={{
            color: "white",
            textAlign: "center",
            lineHeight: "69px",
          }}
        >
          AASSTTIINN WMS
        </Title>
      </div>
      <Menu
        style={{
          width: "100%",
          height: isMobile ? "auto" : "calc(100vh - 69px)",
        }}
        defaultSelectedKeys={activeSection}
        defaultOpenKeys={["sub1"]}
        mode="inline"
        theme="dark"
      >
        {listMenu.map((item) => (
          <Menu.Item key={item.key} icon={item.icon}>
            <Link to={item.path} onClick={() => setVisible(false)}>
              <FormattedMessage id={item.text} />
            </Link>
          </Menu.Item>
        ))}
      </Menu>
    </>
  );
};

export default MainMenu;
